import { LoaderWrapper, Progress }   from '@styles/Shared/StyledLoaders';
import { ReactComponent as PhxLogo } from '../../../svg/img-phx-logo.svg';

export const ILendingLoader = () => (
  <LoaderWrapper>
    <Progress size={25} color="secondary" />
    <PhxLogo />
  </LoaderWrapper>
);
